const contentful = require("contentful");
export const cms = contentful.createClient({
    space: process.env.VUE_APP_CONTENTFUL_SPACE,
    accessToken: process.env.VUE_APP_CONTENTFUL_TOKEN,
    environment: process.env.VUE_APP_CONTENTFUL_ENV
});
